<template>
	<div class="table-responsive">
		<table class="table table-striped tabela">
			<thead>
				<tr>
					<th>Pos</th>
					<th class="text-center">Equipa</th>
					<th class="text-right">Participantes</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(a, index) in dados" :a="a" :index="index" v-if="index < num">
					<td>{{ index + 1 }}</td>
					<td class="text-center">{{ a.equipa }}</td>
					<td class="text-right">{{ a.atletas }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: [
		'dados',
		'num'
	]
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// TabelaEquipasParticipantes.vue?2fd36cc0